module.exports = __webpack_public_path__ + "static/media/1full-min.56165fa6.png";